import { canAccessInternalAdsTools } from '@/lib/adsToolsAccess';
import { cn } from '@/lib/utils';
import { useWorkspaceStore } from '@/stores/useWorkspaceStore';
import { tenantStatusPresentation } from '@/pages/clients/tenantStatusPresentation';
import type { TenantStatus } from '@/types/tenant';

export interface TenantStatusInlineProps {
  website: string;
  status: TenantStatus | string | null;
  /**
   * Retained as an optional prop for older callers; the per-cell Pencil is
   * gone — row edit mode on AllClientsPage owns tenant-status writes now.
   */
  onStatusChanged?: (next: TenantStatus) => void;
}

/**
 * Staff-only read-mode status pill for the /clients Status column. Row
 * edit mode on AllClientsPage swaps this out for `TenantStatusRowEdit`;
 * this component itself no longer swaps to a Select in place.
 */
export function TenantStatusInline({ status }: TenantStatusInlineProps) {
  const userProfile = useWorkspaceStore((state) => state.userProfile);

  if (!canAccessInternalAdsTools(userProfile)) return null;

  const presentation = tenantStatusPresentation(status);

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide',
        presentation.className,
      )}
    >
      {presentation.label}
    </span>
  );
}
